// ModalPizza.tsx - Com destaque visual de campos inválidos
import React, { useState } from 'react';
import Loading from '../../../../Loading/Loading';
import * as S from './styled';
import { StateForm } from '../../../../../interfaces/state-form';
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { AppDispatch, useAppSelector } from '../../../../../redux/store';
import { configPizzaSchema } from '../../../../../redux/features/product/schema';
import * as Yup from 'yup';
import { Navbar } from './nav';
import { Body } from './Body';
import { Footer } from './Footer';
import { handleCloseModal, setConfigUuid } from '../../../../../redux/features/product/product-slice';
import { useDispatch } from 'react-redux';
import {
  createConfigPizzaAsync,
  getConfigPizzaAsync,
  putConfigPizzaAsync,
} from '../../../../../redux/features/product/services';
import { notifyError, notifyWarning } from '../../../../notify/notify-component';
import { 
  validatePizzaConfigBeforeSubmit,
  transformPizzaConfigData,
  logPizzaConfigTransformation 
} from '../../../../../utils/pizzaConfigValidator'; // Ajuste o caminho


type FormData = Yup.InferType<typeof configPizzaSchema>;

interface IProps {
  show: boolean;
  setShow: any;
  idPdv:any;
  produtoEdite: any
}

export interface IActivedTab {
  sabores: boolean;
  borda: boolean;
  extra: boolean;
  comentario: boolean;
}

export default function ModalPizza({ show, setShow, idPdv, produtoEdite }: IProps) {
  const dispatch = useDispatch<AppDispatch>();
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const {flavors, edges, extras, comments, pizzaConfig} = useAppSelector(({ productReducer }) => productReducer.value);
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(configPizzaSchema),
  });
  const inputError = [errors];

  const [activedtab, setActivedtab] = useState<IActivedTab>({
    sabores: true,
    borda: false,
    extra: false,
    comentario: false,
  });

  const [stateForm, setStateForm] = useState<StateForm>({
    state: "default",
    message: "",
  });

  // Estado para rastrear campos inválidos
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  
  
  const onSubmit: SubmitHandler<any> = async (data: FormData) => {
    // Limpar campos inválidos anteriores
    setInvalidFields([]);
    clearErrors();

    // ========== VALIDAÇÃO CUSTOMIZADA ==========
    const validation = validatePizzaConfigBeforeSubmit(data);
    
    if (!validation.isValid) {
      // Marcar campos como inválidos
      setInvalidFields(validation.invalidFields);
      
      // Definir erros no React Hook Form para cada campo inválido
      validation.invalidFields.forEach(fieldName => {
        setError(fieldName, {
          type: 'manual',
          message: 'Este campo é obrigatório'
        });
      });

      // Mostrar mensagens de erro
      validation.errors.forEach(error => notifyWarning(error));
      
      // Scroll para o primeiro campo com erro
      const firstInvalidField = validation.invalidFields[0];
      if (firstInvalidField) {
        const element = document.querySelector(`[name="${firstInvalidField}"]`);
        element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      return; // Interrompe o submit
    }
    // ===========================================

    // Transformar dados para formato correto
    const transformedData = transformPizzaConfigData(data);
    
    // Log de debug (remover em produção)
    logPizzaConfigTransformation(data, transformedData);

    // Montar objeto final para envio
    const newData = {
      ...produtoEdite?.relationships?.pizza_config,
      ItemKeyId: idPdv,
      store_id: storeMe?.storeActive?.id,
      ...transformedData, // Dados já transformados corretamente
      GroupIdForObservation: 1,
      PvpForObservations: 1,
      items: [
        ...flavors,
        ...edges,
        ...extras,
        ...comments
      ]
    };

    console.log('📦 Dados finais para o backend:', newData);

    // Enviar para o backend
    if (!produtoEdite?.relationships?.pizza_config?.uuid) {
      dispatch(createConfigPizzaAsync(newData)).then((result: any) => {
        if (createConfigPizzaAsync.fulfilled.match(result)) {
          dispatch(getConfigPizzaAsync(result?.payload?.uuid))
          dispatch(setConfigUuid(result.payload.uuid))
          handleClose();
        } else if(result) {
          notifyError(result.payload.message ?? "Erro ao registrar produto.");
        }
      });
    } else {
      dispatch(putConfigPizzaAsync(newData)).then((result: any) => {
        if (putConfigPizzaAsync.fulfilled.match(result)) {
          dispatch(getConfigPizzaAsync(result?.payload?.uuid))
          dispatch(setConfigUuid(result.payload.uuid))
          handleClose();
        } else if(result) {
          notifyError(result.payload.message ?? "Erro ao registrar produto.");
        }
      });
    }
  };

  const handleClose = () => {
    setShow(false);
    setActivedtab({
      sabores: true,
      borda: false,
      extra: false,
      comentario: false,
    });
    setInvalidFields([]); // Limpar campos inválidos ao fechar
    clearErrors(); // Limpar erros do formulário
    dispatch(handleCloseModal())
  };


  return (
    <>
      <S.ModalWrapper show={show} onHide={handleClose} centered>
          <S.Wrapper>
            <Navbar activedtab={activedtab} setActivedtab={setActivedtab} />
            <form onSubmit={handleSubmit(onSubmit)}>
              <Body
                activedtab={activedtab}
                stateForm={stateForm}
                inputError={inputError}
                register={register}
                control={control}
                setValue={setValue}
                watch={watch}
                pizzaEdite={pizzaConfig}
                invalidFields={invalidFields} // Passar campos inválidos
              />
              <Footer handleClose={handleClose} type="submit"/>
            </form>
           
          </S.Wrapper>
      </S.ModalWrapper>
      {stateForm.state === "loading" && <Loading />}
    </>
  );
}